export default __webpack_public_path__ + "static/media/bigspender.3b9d0bdc.png";